import React from 'react'
import { flowRight } from 'lodash'
import { withTranslationCustom } from 'lib/i18next'

import RadioGroup from 'components/Forms/FormElements/RadioGroup'

import './ad-status-select.pcss'

const AdStatusSelect = (props) => {
    return <RadioGroup className="ad-status-select" {...props} />
}

export default flowRight(
    withTranslationCustom('vehicles'),
)(AdStatusSelect)
